export type StoryExportTier = "free" | "crafter" | "author";

const tierOrder: Record<StoryExportTier, number> = {
  free: 0,
  crafter: 1,
  author: 2,
};

export function compareStoryExportTier(
  left: StoryExportTier,
  right: StoryExportTier,
) {
  return tierOrder[left] - tierOrder[right];
}

export function isStoryExportTierAllowed(
  tier: StoryExportTier,
  minimumTier: StoryExportTier,
) {
  return compareStoryExportTier(tier, minimumTier) >= 0;
}
